export default __webpack_public_path__ + "static/newsletter_background-db2c723afe40995bfe56ef270d73f748.jpg";